var map = {
	"./Dev.jpg": 465,
	"./Team.jpg": 466,
	"./aboutus.jpg": 467,
	"./app.png": 468,
	"./awards.jpg": 469,
	"./clients.jpg": 470,
	"./cloudcom.png": 471,
	"./consulting.png": 472,
	"./development.jpg": 473,
	"./devop.png": 474,
	"./devops.png": 475,
	"./disclaimer.png": 476,
	"./engagementmodel.jpg": 477,
	"./erp.png": 478,
	"./hireteam.png": 479,
	"./iot.png": 480,
	"./itcons.png": 481,
	"./open-source.png": 482,
	"./opensource.png": 483,
	"./partnership.jpg": 484,
	"./press.png": 485,
	"./privacypolicy.png": 486,
	"./produceng.png": 487,
	"./projectmanagement.jpg": 488,
	"./pwa.png": 489,
	"./qa.jpg": 490,
	"./qa.png": 491,
	"./qatesting.jpg": 492,
	"./sdlc.png": 493,
	"./support.png": 494,
	"./wearable.png": 495,
	"./webecomm.png": 496
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 673;